import { Button } from '@/shared/components';
import useBoolean from '@/shared/hooks/useBoolean';
import { ChatIcon, DotsHorizontalIcon, HelpIcon, LightBulbIcon } from '@/shared/icons/large';
import NavbarDropdown from './NavbarDropdown';

export const MiscNavDropdownLinks = () => {
  const {
    value: isActive,
    setTrue: activateDropdown,
    setFalse: deactivateDropdown,
  } = useBoolean(false);

  return (
    <NavbarDropdown
      title={
        <Button
          type="secondary-standard"
          className="flex min-w-[40px] items-center gap-x-2 whitespace-nowrap bg-transparent !px-0"
        >
          <DotsHorizontalIcon className="h-[38px] w-[38px]" />
        </Button>
      }
      items={[
        {
          item: 'Help & Support',
          Icon: HelpIcon,
          href: 'https://discord.com/channels/824147014140952596/1159396062872743987',
        },
        {
          item: 'Leave feedback',
          Icon: ChatIcon,
          href: 'https://discord.com/channels/824147014140952596/1140570867496132649',
        },
        {
          item: 'Request a feature',
          Icon: LightBulbIcon,
          href: 'https://chainflip.canny.io/feature-requests',
        },
      ].map(({ item, Icon, href }) => ({
        content: (
          <div className="whitespace-nowrap rounded-md p-1 outline-none transition hover:bg-cf-gray-4 hover:text-white">
            <a href={href} target="_blank" className="flex items-center gap-x-2" rel="noreferrer">
              <Icon />
              {item}
            </a>
          </div>
        ),
      }))}
      isActive={isActive}
      onMouseEnter={activateDropdown}
      onMouseLeave={deactivateDropdown}
    />
  );
};
